<template>
  <div>
    <div class="informbox">
      <label>全てのクライアントに通知</label>
    </div>
  </div>
</template>
